export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-arrow-right-72885c06af9554e0985ee561868e5f8f.svg";